// export const BASE_URL = "https://travelbookingupdate-production.up.railway.app/api";
export const BASE_URL = "http://3.133.136.37:5000/api";
